import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import ServiceDetailTab from "./serviceDetailTabs";

const ServiceDetail = () => {
  const [breadcrumb,setBreadcrumb] = useState("")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Service Detail</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Industry" }, { title: breadcrumb }]}
        />
      </div>
      <ServiceDetailTab setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default ServiceDetail;
